/**
 * 商户列表
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/task/merchantList' }">用工中心</el-breadcrumb-item>
      <el-breadcrumb-item>商户列表</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="商户名称 :">
        <el-input
          size="small"
          v-model="formInline.merchantName"
          placeholder="请输入商户名称"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" @click="search">搜索</el-button>
        <el-button size="small" @click="reset()">清空</el-button>
      </el-form-item>
    </el-form>

    <!--列表-->
    <el-table
      size="small"
      :data="listData"
      highlight-current-row
      v-loading="loading"
      element-loading-text="拼命加载中"
      style="width: 100%"
    >
      <!-- <el-table-column align="center" type="selection" width="60">
      </el-table-column> -->
      <el-table-column fixed prop="merchantName" label="商户名称" width="320">
      </el-table-column>
      <el-table-column
        prop="distributeCompanyName"
        label="下发公司"
        width="320"
      >
      </el-table-column>
      <el-table-column
        prop="receiptInfo.accountNumber"
        label="充值账号"
        width="350"
      >
      </el-table-column>
      <el-table-column
        prop="receiptInfo.depositBank"
        label="开户行"
        width="350"
      >
      </el-table-column>
      <el-table-column
        prop="receiptInfo.bankBranchCode"
        label="联行号"
        width="350"
      >
      </el-table-column>
      <el-table-column prop="managementFeeRate" label="管理费率" width="200">
        <template slot-scope="scope">
          <span>{{
            scope.row.managementFeeRate
              ? scope.row.managementFeeRate.toFixed(4)
              : ""
          }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="createTime" label="创建时间" width="230">
      </el-table-column>
      <el-table-column label="合同" width="150">
        <template v-slot:default="scope">
          <el-button type="text" @click="viewContract(scope.row)"
            >查看</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination
      v-bind:child-msg="pageparm"
      @callFather="callFather"
    ></Pagination>
    <!-- 编辑界面 -->
  </div>
</template>

<script>
import { getMerchantLsit } from "../../api/userMG";
import Pagination from "../../components/Pagination";
export default {
  data() {
    return {
      nshow: true, //switch开启
      fshow: false, //switch关闭
      loading: false, //是显示加载

      // rules表单验证 unit
      rules: {},
      formInline: {
        page: 1,
        pageSize: 10,
        merchantName: "",
      },
      // 删除部门
      seletedata: {
        ids: "",
        token: localStorage.getItem("logintoken"),
      },
      userparm: [], //搜索权限
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        page: 1,
        pageSize: 10,
        total: 10,
      },
    };
  },
  // 注册组件
  components: {
    Pagination,
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.getdata();
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    viewContract(row) {
      if (row.contract) {
        if (row.contractStatus == 3) {
          // 如果 URL 不为空，在新标签页中打开 PDF 文件
          window.open(row.contract, "_blank");
        } else {
          this.$message.error("合同正在签署中，请归档后查看。");
        }
      } else {
        this.$message.error("合同未上传，请联系管理员上传。");
      }
      // window.open(url, "_blank");
    },
    reset() {
      this.formInline = {
        page: 1,
        pageSize: 10,
        merchantName: "",
      };
      this.getdata(this.formInline);
    },

    // 获取公司列表
    getdata() {
      let params = {
        page: this.formInline.page,
        pageSize: this.formInline.pageSize,
        merchantName: this.formInline.merchantName,
      };
      this.loading = true;
      /***
       * 调用接口，注释上面模拟数据 取消下面注释
       */
      getMerchantLsit(params)
        .then((res) => {
          this.loading = false;
          if (res.msg == "success") {
            this.listData = res.data.records;
            this.pageparm.page = res.data.current;
            this.pageparm.pageSize = res.data.size;
            this.pageparm.total = res.data.total;
          } else {
            this.$message({
              type: "error",
              message: res.msg,
            });
          }
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.page;
      this.formInline.pageSize = parm.pageSize;
      this.getdata(this.formInline);
    },
    // 搜索事件
    search() {
      this.getdata(this.formInline);
    },
  },
};
</script>

<style scoped>
.user-search {
  margin-top: 20px;
  margin-bottom: 10px;
  padding: 10px;
  background-color: #fff;
}
/* .el-form-item {
  margin-bottom: 10px !important;
} */
.el-form-item {
  margin-bottom: 20px !important; /* 调整间距 */
}

.el-textarea__inner {
  height: 100px; /* 调整文本区域的高度 */
}

/* 保证验证文字显示 */
.el-form-item__error {
  color: #f56c6c;
  font-size: 12px;
  line-height: 1;
  padding: 4px 0 0;
  position: absolute;
  top: 100%;
  width: 100%;
}

/* 保证字数限制提示显示 */
.el-input__count {
  position: absolute;
  bottom: -20px; /* 调整位置 */
  right: 15px;
  color: #909399;
  font-size: 12px;
}
.userRole {
  width: 100%;
}
.info-block {
  background: #fff;
  border: 1px solid #e5e5e5;
  margin-bottom: 20px;
}
.info-block .info-title {
  background-color: #f0f2f5;
  margin: 0 !important;
  font-size: 16px;
  padding: 0 32px;
  line-height: 56px;
  border-bottom: 1px solid #e5e5e5;
}
.info-block .info-body {
  padding: 24px 32px;
}
.blockTitle span:nth-child(2) {
  font-size: 18px;
  color: #272727;
  margin-top: 10px;
  font-weight: 700;
}
.blockTitleOrage span:nth-child(2) {
  color: #ff943e;
  font-weight: 700;
  font-size: 20px;
  margin-top: 10px;
}
</style>

 


// WEBPACK FOOTER //
// src/views/task/merchantList.vue